import React, { FC } from 'react';
import { Props } from './interfaces';
import * as S from './styles';

export const Card: FC<Props> = ({ children }) => {
  return <S.Card>{children}</S.Card>;
};
